/**
 * @enum {string}
 */
enum FormAction {
  /** The form is used to create a new JE. */
  New = "new",
  /** The form is used to edit an existing JE. */
  Edit = "edit",
  /** The form is used to view an existing JE. */
  Show = "show"
}

export default FormAction;
